// src/components/ThemeProvider.jsx
import React, { Component } from "react";
import { ThemeContext } from "./ThemeContext";

class ThemeProvider extends Component {
  constructor(props) {
    super(props);
    const savedTheme = localStorage.getItem("theme") || "light";
    this.state = { theme: savedTheme };
  }

  toggleTheme = () => {
    this.setState(
      (prev) => ({ theme: prev.theme === "light" ? "dark" : "light" }),
      () => {
        document.body.className = this.state.theme === "dark" ? "theme-dark" : "theme-light";
        localStorage.setItem("theme", this.state.theme);
      }
    );
  };

  componentDidMount() {
    document.body.className = this.state.theme === "dark" ? "theme-dark" : "theme-light";
  }

  render() {
    return (
      <ThemeContext.Provider value={{ theme: this.state.theme, toggleTheme: this.toggleTheme }}>
        {this.props.children}
      </ThemeContext.Provider>
    );
  }
}

export default ThemeProvider;
